import { compareAttachments, type GenieAttachment } from "@/types/voice/genie-attachment";

/**
 * Everything showRelatedMedia found in the current conversation, best first,
 * including what the chat had no room for. The voice service adds to it; the
 * Resources sheet lists it through useFoundMedia.
 */
let found: GenieAttachment[] = [];
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

export const foundMedia = {
  add(items: GenieAttachment[]): void {
    const known = new Set(found.map((item) => item.url));
    const fresh = items.filter((item) => !known.has(item.url));
    if (fresh.length === 0) return;
    found = [...found, ...fresh].sort(compareAttachments);
    notify();
  },

  /** Empties the list, for when a new conversation starts. */
  clear(): void {
    if (found.length === 0) return;
    found = [];
    notify();
  },

  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  list: (): GenieAttachment[] => found,
};
